// extracted by mini-css-extract-plugin
export var headerCell = "_1h-1";
export var loadingSpinnerContainer = "_1h-4";
export var rowWrapper = "_1h-3";
export var standaloneTable = "_1h-5";
export var table = "_1h-0";
export var white = "_1h-2";